import { render } from "./ReceiptForm.vue?vue&type=template&id=7703302a"
import script from "./ReceiptForm.vue?vue&type=script&lang=js"
export * from "./ReceiptForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vhstrejo/Sites/todo-inclusion/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__